import React from 'react';
import { Container, Text } from '@soluto-design/react';
import Media, { MediaProps } from '../../molecules/Media';

export interface StorySectionProps {
    title: string;
    text?: string;
    media?: MediaProps['media'];
}

export default function StorySection({
    title,
    text,
    media,
}: StorySectionProps) {
    return (
        <section className="my-mega">
            <Container>
                {!!title && (
                    <Text
                        component="h3"
                        className="text-h300 text-text-primary">
                        {title}
                    </Text>
                )}
                {!!text && (
                    <Text
                        isHtml
                        component="div"
                        className="text-b300 text-text-primary pt-xl lg:columns-2 lg:gap-x-gutter [&_p]:pb-md lg:[&>p:last-child]:pb-0">
                        {text}
                    </Text>
                )}
                {!!media && (
                    <Media
                        className="rounded-medium !w-full mt-[calc(var(--soluto-spacing-xl)-var(--soluto-spacing-md))]"
                        media={media}
                        layout="responsive"
                    />
                )}
            </Container>
        </section>
    );
}
